import React from 'react';
import { WarningCallOut } from '@grnhse/seedling/lib/birch/components/call_out';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { withLocalePrefix } from '../shared/utils/translation';

const t = withLocalePrefix('authorization.authorization_form');

type Props = {
  host: string;
  loopbackOnly?: boolean;
};

export default function RedirectDestination({ host, loopbackOnly }: Props) {
  return (
    <Stack spacing={2}>
      <Body>{t('redirects_to', { host })}</Body>
      {loopbackOnly && (
        <WarningCallOut
          data-test={'loopback-only-warning'}
          headerText={t('loopback_only_header')}
          bodyText={t('loopback_only_notice')}
        />
      )}
    </Stack>
  );
}
